import { DigitRoll } from '../digit-roll';

const TILE = 'h-[101px] w-[74px]';
/**
 * Three, as Figma draws it, even at zero. `donation-count`'s `TOTAL` is capped to the same three
 * digits, so the row never grows a fourth tile mid-visit and shifts the copy beside it.
 */
const MIN_TILES = 3;

/**
 * One tile: the shared 0–9 roll, behind an orange card. Everything here is the card and the type; the
 * column that does the rolling is `DigitRoll`, and the roll itself is pure CSS — including its own
 * reduced-motion behaviour, which is why no flag is threaded down to it.
 */
function DigitTile(props: { value: number }) {
	return (
		<DigitRoll
			digit={props.value}
			className={`bg-brand rounded-lg ${TILE}`}
			cell={`flex items-center justify-center text-[4.5rem] leading-none font-medium tracking-[-0.02em] text-black tabular-nums ${TILE}`}
		/>
	);
}

/**
 * The rolling counter of the Solutions hero. Presentational only — it renders whatever `count` it is
 * given. Screen readers get the plain number; the tiles are just the animation of it.
 */
export function DonationOdometer(props: { count: number }) {
	const digits = String(props.count).padStart(MIN_TILES, '0').split('').map(Number);

	return (
		<div className="flex shrink-0 gap-2" role="status" aria-live="polite" aria-atomic>
			<span className="sr-only">{props.count}</span>
			{digits.map((d, i) => (
				// oxlint-disable-next-line react/no-array-index-key
				<DigitTile key={i} value={d} />
			))}
		</div>
	);
}
